import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    accessToken: null,
    loggingIn: false,
    loginError: null,
  },
  mutations: {
    loginStart: (state) => {
      // eslint-disable-next-line
      state.loggingIn = true;
    },
    loginStop: (state, errorMessage) => {
      // eslint-disable-next-line
      state.loggingIn = false;
      // eslint-disable-next-line
      state.loginError = errorMessage;
    },
    updateAccessToken: (state, accessToken) => {
      // eslint-disable-next-line
      state.accessToken = accessToken;
    },
    logout: (state) => {
      // eslint-disable-next-line
      state.accessToken = null;
    },
  },
  actions: {
    doLogin(context, payload) {
      return new Promise((resolve, reject) => {
        context.commit('loginStart');
        window.axios.post(`WebLogin?_username=${payload.user}&_password=${payload.pass}`).then((response) => {
          if (response.data.Result === 'TRUE') {
            const name = btoa(response.data.Note1);
            const level = btoa(response.data.Note2);
            const user = btoa(payload.user);
            const pass = btoa(payload.pass);
            const today = new Date();
            today.setDate(today.getDate() + 1);
            const head = Math.random().toString(36).substr(2);
            const tokenid = `GN${head}.${name}.${level}.${today.getTime()}.${user}.${pass}`;
            localStorage.setItem('accessToken', tokenid);
            context.commit('loginStop', null);
            context.commit('updateAccessToken', tokenid);
            resolve('success');
          } else {
            const message = 'Username or Password not found';
            context.commit('loginStop', message);
            context.commit('updateAccessToken', null);
            reject(message);
          }
        }).catch((error) => {
          const message = "We're sorry, a server error occurred. Please wait a bit and try again or contact Technical Support";
          context.commit('loginStop', error);
          context.commit('updateAccessToken', null);
          reject(message);
        });
      });
    },
    fetchAccessToken(context) {
      context.commit('updateAccessToken', localStorage.getItem('accessToken'));
    },
    logout(context) {
      return new Promise((resolve) => {
        localStorage.removeItem('accessToken');
        context.commit('logout');
        resolve(true);
      });
    },
    changePass(context, payload) {
      return new Promise((resolve, reject) => {
        context.commit('loginStart');
        window.axios.post(`WebChangePassword?_username=${payload.user}&_oldPassword=${payload.old}&_newPassword=${payload.new}`).then((response) => {
          if (response.data.Result === 'TRUE') {
            window.axios.post(`WebLogin?_username=${payload.user}&_password=${payload.newpass}`).then((res) => {
              if (res.data.Result === 'TRUE') {
                const name = btoa(res.data.Note1);
                const level = btoa(res.data.Note2);
                const user = btoa(payload.user);
                const pass = btoa(payload.pass);
                const today = new Date();
                today.setDate(today.getDate() + 1);
                const head = Math.random().toString(36).substr(2);
                const tokenid = `GN${head}.${name}.${level}.${today.getTime()}.${user}.${pass}`;
                localStorage.setItem('accessToken', tokenid);
                context.commit('loginStop', null);
                context.commit('updateAccessToken', tokenid);
                resolve('success');
              } else {
                const message = 'Username or Password not found';
                context.commit('loginStop', message);
                reject(message);
              }
            }).catch((error) => {
              context.commit('loginStop', error.res.data.statusText);
              reject(error.res.data.statusText);
            });
          } else {
            context.commit('loginStop', response.data.Note1);
            reject(response.data.Note1);
          }
        }).catch((error) => {
          context.commit('loginStop', error.response.data.statusText);
          reject(error.response.data.statusText);
        });
      });
    },
  },
});
